import {GROUP_MEMBERS_TYPE} from '../../../../constants/GroupMembersType';

// AD-2699: the same request the 'Report Generation' box sends (DownloadReportPopup handleGenerate), so the file is
// the same for the same choices.
export const reportPayload = ({memberType, settings, excludedFields, strictRecipientsFiltering}) => {
    const basePayload = {
        excludedFields,
        filterIds: settings.groupFilters.filter(e => !e.excluded).map(e => e.id),
        excludedFilterIds: settings.groupFilters.filter(e => e.excluded).map(e => e.id),
        strictRecipientsFiltering
    };

    return memberType === GROUP_MEMBERS_TYPE.employee
        ? {
            ...basePayload,
            employeeIds: settings.employeeFilters.map(e => e.id)
        }
        : {
            ...basePayload,
            studentIds: [
                ...settings.studentFilters.map(e => e.id),
                ...settings.applicationFilters.map(e => e.id),
                ...settings.enquiryFilters.map(e => e.id)
            ]
        };
};

// Reads the CSV the server returns: the header, the first rows and the number of rows.
export const parseCsv = (text) => {
    const rows = [];
    let row = [];
    let cell = '';
    let quoted = false;
    const source = text.replace(/^\uFEFF/, '');

    for (let i = 0; i < source.length; i++) {
        const ch = source[i];
        if (quoted) {
            if (ch === '"' && source[i + 1] === '"') {
                cell += '"';
                i++;
            } else if (ch === '"') {
                quoted = false;
            } else {
                cell += ch;
            }
        } else if (ch === '"') {
            quoted = true;
        } else if (ch === ',') {
            row.push(cell);
            cell = '';
        } else if (ch === '\n' || ch === '\r') {
            if (ch === '\r' && source[i + 1] === '\n') i++;
            row.push(cell);
            rows.push(row);
            row = [];
            cell = '';
        } else {
            cell += ch;
        }
    }
    if (cell !== '' || row.length) {
        row.push(cell);
        rows.push(row);
    }
    return rows.filter(r => r.some(value => value !== ''));
};

export const firstRowsOfCsv = (text, limit) => {
    const [header = [], ...rows] = parseCsv(text);
    return {header, rows: rows.slice(0, limit), count: rows.length};
};

// The server's own words when the choices give an empty report (GetDispenseReportQueryHandlerBase,
// GetMedicalEventsReportQueryHandlerBase): the preview says so plainly instead of showing an error.
export const isEmptyReportMessage = (message = '') =>
    /^(none of the chosen students were given medicine|no medicine was given|there were no medical events|unable to generate report: no students or applicants found)/i
        .test(message.trim());
